import React, { FC, useMemo } from 'react';
import { MapModeEnum } from '../../slice/types';
import { createGroupMarkerIcon } from '../../../../components/MarkerIcon/MarkerIcon';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import TempFields from './TempFields/TempFields';
import Fields from './Fields/Fields';
import SingleFieldOnMap from './SingleFieldOnMap/SingleFieldOnMap';
import TaskFields from './TaskFields/TaskFields';
import ProgressUpdateFields from './ProgressUpdateFields/ProgressUpdateFields';
import CultureFields from './CultureFields/CultureFields';
import CreatePolygon from './CreatePolygon/CreatePolygon';
import EditPolygon from './EditPolygon/EditPolygon';
import RoutesWithoutTaskMapItems from './RoutesWithoutTaskMapItems/RoutesWithoutTaskMapItems';
import TaskRoutesMapItems from './TaskRoutesMapItems/TaskRoutesMapItems';
import AllRoutesMapItems from './AllRoutesMapItems/AllRoutesMapItems';
import SingleTaskFieldRoutes from './SingleTaskFieldRoutes/SingleTaskFieldRoutes';

interface IProps {
  readOnly?: boolean;
  mode: MapModeEnum;
}

const FieldsByMapType: FC<IProps> = ({ readOnly, mode }) => {
  const fieldsByMapMode = useMemo(() => {
    switch (mode) {
      case MapModeEnum.upload:
        return <TempFields />;

      case MapModeEnum.taskFields:
        return (
          <>
            <TaskFields />
            <SingleTaskFieldRoutes />
          </>
        );

      case MapModeEnum.progress:
        return <ProgressUpdateFields />;

      case MapModeEnum.singleField:
        return <SingleFieldOnMap />;

      case MapModeEnum.culture:
        return <CultureFields />;

      case MapModeEnum.runsWithoutTask:
        return <RoutesWithoutTaskMapItems />;

      case MapModeEnum.taskRoutes:
        return <TaskRoutesMapItems />;

      case MapModeEnum.fieldsAndRoutes:
        return (
          <>
            <Fields mode={mode} readOnly={readOnly} />
            <AllRoutesMapItems />
          </>
        );

      default:
        return <Fields mode={mode} readOnly={readOnly} />;
    }
  }, [mode, readOnly]);

  if (mode === MapModeEnum.createPolygon) {
    return <CreatePolygon />;
  }
  if (mode === MapModeEnum.editPolygon) {
    return <EditPolygon />;
  }

  return (
    <MarkerClusterGroup
      showCoverageOnHover={false}
      zoomToBoundsOnClick
      removeOutsideVisibleBounds
      iconCreateFunction={createGroupMarkerIcon}
    >
      {fieldsByMapMode}
    </MarkerClusterGroup>
  );
};

export default FieldsByMapType;
